import React from "react"

export const ExportIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.4398 7.25C14.2498 7.25 14.0598 7.18001 13.9098 7.03L11.8798 5L9.84977 7.03C9.55977 7.32 9.07977 7.32 8.78977 7.03C8.49977 6.74001 8.49977 6.26 8.78977 5.97L11.3498 3.41C11.6398 3.12 12.1198 3.12 12.4098 3.41L14.9698 5.97C15.2598 6.26 15.2598 6.74001 14.9698 7.03C14.8198 7.18001 14.6298 7.25 14.4398 7.25Z"
        fill="#1D1D1D"
      />
      <path
        d="M11.8799 14.93C11.4699 14.93 11.1299 14.59 11.1299 14.18V4.00999C11.1299 3.59999 11.4699 3.25999 11.8799 3.25999C12.2899 3.25999 12.6299 3.59999 12.6299 4.00999V14.18C12.6299 14.6 12.2899 14.93 11.8799 14.93Z"
        fill="#1D1D1D"
      />
      <path
        d="M12 20.75C6.85 20.75 3.25 17.15 3.25 12C3.25 11.59 3.59 11.25 4 11.25C4.41 11.25 4.75 11.59 4.75 12C4.75 16.27 7.73 19.25 12 19.25C16.27 19.25 19.25 16.27 19.25 12C19.25 11.59 19.59 11.25 20 11.25C20.41 11.25 20.75 11.59 20.75 12C20.75 17.15 17.15 20.75 12 20.75Z"
        fill="#1D1D1D"
      />
    </svg>
  )
}
